module.exports = __webpack_public_path__ + "static/media/pts_award_2022.85200204.jpg";